import { api } from '@/fsd/shared/api';

export const accountCabinetOnboardingDismiss = async () => {
  return await api.post(`/api/v1/account/cabinet/onboarding/dismiss/`);
};
